
import Rating from "./rating";

const title = "02 Commentaires";


const commentList = [
    {
        imgUrl: 'assets/images/author/02.jpg',
        imgAlt: 'rajibraj91',
        name: 'Linsa Faith',
        date: '5 juin 2022 à 12h41',
        desc: 'Le sanctuaire intérieur, je me jette parmi les hautes herbes au bord du ruisseau trckli et, alors que je suis allongé près de la terre',
    },
    {
        imgUrl: 'assets/images/author/03.jpg',
        imgAlt: 'rajibraj91',
        name: 'Mahdi Mahmud',
        date: '1 juin 2022 à 09h15',
        desc: 'Le sanctuaire intérieur, je me jette parmi les hautes herbes au bord du ruisseau trckli et, alors que je suis allongé près de la terre',
    },
]


const Comment = () => {
    return (
        <div className="comments">
            <h4 className="title-border">{title}</h4>
            <ul className="comment-list">
                {commentList.map((val, i) => (
                    <li className="comment" key={i}>
                        <div className="com-thumb">
                            <img src={`${val.imgUrl}`} alt={`${val.imgAlt}`} />          
                        </div>
                        <div className="com-content">
                            <div className="com-title">
                                <div className="com-title-meta">
                                    <h6>{val.name}</h6>
                                    <span> {val.date} </span>
                                </div>
                                <Rating />
                            </div>
                            <p>{val.desc}</p>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
}
 
export default Comment;